export default {
  assignments: null,

  currentAssignmentArea: null, // currently selected "assignment area" to assign
  currentSubArea: null, // the subarea where the assignments will happen

  userToAssign: null // temporarily store the user we want to assign to a stand
}
